import { Controller } from "@hotwired/stimulus"

// Shows the free text field for the location only when "other" is selected.
export default class extends Controller {
  static targets = ["select", "note"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isOther = this.selectTarget.value === "other"
    this.noteTargets.forEach((el) => el.classList.toggle("hidden", !isOther))
  }
}
